import { Chip } from "@amzn/stencil-react-components/chip";
import { withTooltip } from "@amzn/stencil-react-components/dist/submodules/tooltip";
import { Input } from "@amzn/stencil-react-components/input";
import { Col, Row } from "@amzn/stencil-react-components/layout";
import { Label, Text } from "@amzn/stencil-react-components/text";
import { TextArea } from "@amzn/stencil-react-components/text-area";
import IconQuestionCircle from "@amzn/stencil-react-icons/icons/icon-question-circle";
import React, { FC } from "react";
export const STRING_PATH = "checkout.formPanel.managerCard";

export interface FormFieldProps {
  label: string;
  value: string;
  onChange: (value: string) => void;
  placeholder: string;
  chipText?: string;
  testId: string;
  isTextArea?: boolean;
  tooltipText?: string;
}

export const FormField: FC<FormFieldProps> = ({
  label,
  value,
  onChange,
  placeholder,
  chipText,
  testId,
  isTextArea,
  tooltipText,
}) => {
  const IconWithTooltip = withTooltip()(IconQuestionCircle);
  return (
    <Col gridGap="S200" width="85%">
      <Row>
        <Label margin={"S200"}>{label}</Label>
        {tooltipText && <IconWithTooltip tooltipText={tooltipText} />}
      </Row>
      {isTextArea ? (
        <TextArea
          data-testid={testId}
          resize="none"
          placeholder={placeholder}
          value={value}
          onChange={(e) => onChange(e.target.value)}
        />
      ) : (
        <Input
          data-testid={testId}
          placeholder={placeholder}
          value={value}
          onChange={(e) => onChange(e.target.value)}
        />
      )}
      {chipText && (
        <Chip>
          <Text color="neutral90" fontSize="T100">
            {chipText}
          </Text>
        </Chip>
      )}
    </Col>
  );
};
